
const figureObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                figureStepAdd(target)
                // 可见区域后 下次不在执行监听
                figureObserver.unobserve(target)
            }
        })
    },
    {
        // 默认值为null，也就是视口区域,表示监听的可视区域为整个视口，也就是浏览器的可视区域
        root: null,
        // 属性决定了什么时候触发回调函数。默认为[0] 比如，[0, 0.25, 0.5, 0.75, 1]就表示当目标元素 0%、25%、50%、75%、100% 可见时，会触发回调函数。
        threshold: [1],
        // 定义根元素的margin,用来扩展可视区的范围,或者可以这样理解，root元素，多了一个margin属性，如果没有这个margin属性，
        // ele元素只有与root元素开始交叉时才会触发可视性的变化，而这个rootMargin属性的话，就是当ele元素与root元素的外边距交叉时，就会触发ele元素的可视性变化。
        rootMargin: '0px'
    }
)

let eles = document.querySelectorAll('.figure-step-add')
for(let ele of eles){
    figureObserver.observe(ele)
}

const figureStepAdd = ele => {
    let figure = ele.getAttribute('figure') || 0;
    if(parseInt(figure) === parseFloat(figure)) {
        // 整数
        let startVal = 0
        ele.innerHTML = 0;
        let interval1 = setInterval(() => {
            if(startVal + 10 < figure) {
                startVal = startVal + 10
                ele.innerHTML = startVal
            } else {
                clearInterval(interval1)
                let interval2 = setInterval(() => {
                    if(startVal + 1 <= figure) {
                        startVal = startVal + 1
                        ele.innerHTML = startVal
                    } else {
                        clearInterval(interval2)
                    }
                }, 200)
            }
        },100)
    } else {
        // 小数
        let startVal = 0.0
        ele.innerHTML = 0.0;
        let interval1 = setInterval(() => {
            if(startVal + 0.5 < figure) {
                startVal = startVal + 0.5
                ele.innerHTML = startVal.toFixed(1)
            } else {
                clearInterval(interval1)
                let interval2 = setInterval(() => {
                    if(startVal + 0.1 <= figure) {
                        startVal = startVal + 0.1
                        startVal = Number(startVal.toFixed(1))
                        ele.innerHTML = startVal
                    } else {
                        clearInterval(interval2)
                    }
                }, 200)
            }
        },100)
    }
}


const barWidthObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                target.style.animation = 'barIncreaseWidth 3s ease'
                barWidthObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)


let barWidthList = document.querySelectorAll('.chart-item-bar-width')
for(let bar of barWidthList){
    barWidthObserver.observe(bar)
}

const barHeightObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                target.style.animation = 'barIncreaseHeight 2s ease'
                barHeightObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)


let barHeightList = document.querySelectorAll('.chart-item-bar-height')
for(let bar of barHeightList){
    barHeightObserver.observe(bar)
}



const sectorObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                sectorAnimation(target)
                sectorObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)

let sectors = document.querySelectorAll('.article-forth-circle-chart')
for(let sector of sectors){
    sectorObserver.observe(sector)
}

const sectorAnimation = ele => {
    let figure = ele.getAttribute('figure') || 0,
        startVal = 0;
    if(parseInt(figure) === parseFloat(figure)){
        ele.style.background = 'conic-gradient(rgba(255, 124, 120, 1) 0, rgba(235, 15, 48, 1) 0%, #FFFFFF 0%, #FFFFFF 100%)';
        let interval = setInterval(() => {
            if(startVal + 5 <= figure) {
                startVal = startVal + 5
                ele.style.background = `conic-gradient(rgba(255, 124, 120, 1) 0, rgba(235, 15, 48, 1) ${startVal}%, #FFFFFF ${Number(startVal) + .5}%, #FFFFFF 100%)`;
            } else {
                ele.style.background = `conic-gradient(rgba(255, 124, 120, 1) 0, rgba(235, 15, 48, 1) ${figure}%, #FFFFFF ${Number(figure) + .5}%, #FFFFFF 100%)`;
                clearInterval(interval)
            }
        },100)
    } else {
        figure = parseInt(figure)
        ele.style.background = 'conic-gradient(rgba(255, 124, 120, 1) 0, rgba(235, 15, 48, 1) 0%, #FFFFFF 0%, #FFFFFF 100%)';
        let interval = setInterval(() => {
            if(startVal + 5 <= figure) {
                startVal = startVal + 5
                ele.style.background = `conic-gradient(rgba(255, 124, 120, 1) 0, rgba(235, 15, 48, 1) ${startVal}%, rgba(235, 15, 48, 1) ${Number(startVal) + .5}%, rgba(255, 124, 120, 1) 100%)`;
            } else {
                ele.style.background = `conic-gradient(rgba(255, 124, 120, 1) 0, rgba(235, 15, 48, 1) ${figure}%, rgba(235, 15, 48, 1) ${Number(figure) + .5}%, rgba(255, 124, 120, 1) 100%)`;
                clearInterval(interval)
            }
        },100)
    }
}

